import { epCommunityFieldsResolvers } from "./10-community/fields";
import { epCommunityQueries } from "./10-community/queries";
import { epExamLevelFieldsResolvers } from "./20-exam-level/fields";
import { epExamLevelQueries } from "./20-exam-level/queries";
import { epSubjectFieldsResolvers } from "./30-subject/fields";
import { epSubjectQueries } from "./30-subject/queries";
import { epQPFieldsResolvers } from "./40-question-paper/fields";
import { epQPQueries } from "./40-question-paper/queries";
import { epQuestionFieldsResolvers } from "./50-question/fields";
import { epQuestionMutations } from "./50-question/mutations";
import { epQuestionQueries } from "./50-question/queries";
import { epAnswerFieldsResolvers } from "./60-answer/fields";
import { epAnswerQueries } from "./60-answer/queries";
import { epExaminerFeedbackFieldsResolvers } from "./70-examiner-feedback/fields";
import { epEFQueries } from "./70-examiner-feedback/queries";
import { epDiagramFieldsResolvers } from "./80-diagram/fields";
import { epDiagramQueries } from "./80-diagram/queries";
const epResolvers = {
    fields: {
        ...epCommunityFieldsResolvers,
        ...epExamLevelFieldsResolvers,
        ...epSubjectFieldsResolvers,
        ...epQPFieldsResolvers,
        ...epQuestionFieldsResolvers,
        ...epAnswerFieldsResolvers,
        ...epExaminerFeedbackFieldsResolvers,
        ...epDiagramFieldsResolvers,
    },
    Query: {
        ...epCommunityQueries,
        ...epExamLevelQueries,
        ...epSubjectQueries,
        ...epQPQueries,
        ...epQuestionQueries,
        ...epAnswerQueries,
        ...epEFQueries,
        ...epDiagramQueries,
    },
    Mutation: {
        ...epQuestionMutations,
    },
};
export default epResolvers;
